export const url = (window.location.href.includes('localhost') ? 'http://127.0.0.1:8000' : 'https://api.shayanwahedi.com')